import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { CompetitionConsentNames } from "shared/modals/competitionLegalsModal/types";
import { AppTester } from "supporting";
import * as yup from 'yup';

export const useGetCompetitionConsentConfig = (shouldSignConsent?: boolean, consents?: CompetitionConsentNames[]) => {
    const { t, i18n: {language} } = useTranslation();
    const [extraConfig, setExtraConfig] = useState<any>({});

    useEffect(() => {
      let config: any = {};
        if (shouldSignConsent) {
          config['consentFile'] = {
              type: 'file',
              label: 'Загрузите документ',
              accept: 'image/jpeg,image/gif,image/png,application/pdf',
              multiple: false,
              maxSizeMB: 10,
              allowedExtensions: ['pdf', 'jpg', 'jpeg', 'png', 'gif'],
              validation: yup
                .mixed<FileList>()
                .required(t('competition_edit.form.message.required.required_field'))
                .test('fileSize', t('competition_edit.form.message.max_file_size', {size: 10}), function (value) {
                  const maxSize = 10 * 1024 * 1024;
                  if (!value?.length) return true;
                  return value[0].size <= maxSize;
                })
                .test('fileType',t('competition_edit.form.message.image_format'), function (value) {
                  if (!value?.length) return true;
                  const file = value[0];
                  const extension = file.name.split('.').pop()?.toLowerCase();
                  return ['pdf', 'jpg', 'jpeg', 'png', 'gif'].includes(extension || '');
                }),
            }
        }
        if (consents?.includes(CompetitionConsentNames.CONSENT_TO_USE)) {
          config['consentToUse'] ={
            type: 'radio',
            label: 'consentToUse',
            // requiredLabel: true,
            placeholder: '',
            validation: yup
                .boolean(),
            defaultValue: false
                // .required('Обязательное поле')
          }
        }

        if (consents?.includes(CompetitionConsentNames.CONSENT_TO_DEMONSTRATE)) {
          config['consentToDemonstrate'] ={
            type: 'checkbox',
            label: 'consentToDemonstrate',
            // requiredLabel: true,
            placeholder: '',
            validation: yup
                .boolean(),
            defaultValue: false
                // .required('Обязательное поле')
          }
        }

        setExtraConfig(config)
        
    } , [language, t])

    if (!shouldSignConsent && !consents?.length) return {}

    return extraConfig
}import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { CompetitionConsentNames } from "shared/modals/competitionLegalsModal/types";
import { AppTester } from "supporting";
import * as yup from 'yup';

export const useGetCompetitionConsentConfig = (shouldSignConsent?: boolean, consents?: CompetitionConsentNames[]) => {
    const { t, i18n: {language} } = useTranslation();
    const [extraConfig, setExtraConfig] = useState<any>({});

    useEffect(() => {
      let config: any = {};
        if (shouldSignConsent) {
          config['consentFile'] = {
              type: 'file',
              label: 'Загрузите документ',
              accept: 'image/jpeg,image/gif,image/png,application/pdf',
              multiple: false,
              maxSizeMB: 10,
              allowedExtensions: ['pdf', 'jpg', 'jpeg', 'png', 'gif'],
              validation: yup
                .mixed<FileList>()
                .required(t('competition_edit.form.message.required.required_field'))
                .test('fileSize', t('competition_edit.form.message.max_file_size', {size: 10}), function (value) {
                  const maxSize = 10 * 1024 * 1024;
                  if (!value?.length) return true;
                  return value[0].size <= maxSize;
                })
                .test('fileType',t('competition_edit.form.message.image_format'), function (value) {
                  if (!value?.length) return true;
                  const file = value[0];
                  const extension = file.name.split('.').pop()?.toLowerCase();
                  return ['pdf', 'jpg', 'jpeg', 'png', 'gif'].includes(extension || '');
                }),
            }
        }
        if (consents?.includes(CompetitionConsentNames.CONSENT_TO_USE)) {
          config['consentToUse'] ={
            type: 'radio',
            label: 'consentToUse',
            // requiredLabel: true,
            placeholder: '',
            validation: yup
                .boolean(),
            defaultValue: false
                // .required('Обязательное поле')
          }
        }

        if (consents?.includes(CompetitionConsentNames.CONSENT_TO_DEMONSTRATE)) {
          config['consentToDemonstrate'] ={
            type: 'checkbox',
            label: 'consentToDemonstrate',
            // requiredLabel: true,
            placeholder: '',
            validation: yup
                .boolean(),
            defaultValue: false
                // .required('Обязательное поле')
          }
        }

        setExtraConfig(config)
        
    } , [language, t])

    if (!shouldSignConsent && !consents?.length) return {}

    return extraConfig
}